






















import { Component, Prop, Watch, Vue } from 'vue-property-decorator';
import { TaskConfig } from './../type/TaskConfig'

// components
import NavTitle from './NavTitle.vue'
import TabItem from './TabItem.vue'

@Component({
  components: {
    NavTitle,
    TabItem,
  }
})
export default class TaskList extends Vue {

  tabList: string[] = this.$store.state.taskTab
  inTab: string = this.tabList[0]

  get taskList(): TaskConfig[] {
    return this.$store.state.taskList
  }

  get showList(): TaskConfig[] {
    let filter: boolean, list: TaskConfig[]
    switch(this.inTab){
      case 'todo' : filter = false; break;
      case 'done' : filter = true; break;
    }
    list = this.taskList.filter((obj: TaskConfig) => (obj.isDone === filter))
    return list
  }

  async mounted() {
    await this.$store.dispatch('GET_TASK')
  }

  tabSelectHandler(tab: string) {
    this.inTab = tab
  }

  openSectionHandler(id: number) {
    if(this.showList[id].isEdite) this.showList[id].isEdite = false
    else this.showList[id].isEdite = true
  }

}
